<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Details de la livraison</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="titre"><strong>Titre : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="titre" v-model="titre" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="numero_version"><strong>Numero version : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="numero_version" v-model="numero_version" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="contenu"><strong>Contenu : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea type="textarea" id="contenu" v-model="contenu" disabled></b-form-textarea>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="commentaire"><strong>Commentaire : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="commentaire" v-model="commentaire" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="date_livraison"><strong>Date</strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="date" id="date_livraison" v-model="date_livraison" disabled></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from "../../../utils/auth";

  export default {
    name: "Edit",
    data() {
      return {
        titre: "",
        numero_version: "",
        contenu: "",
        commentaire: "",
        date_livraison: "",
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getLivraison();
    },
    methods: {
      getLivraison() {
        this.$store.commit('IS_LOADING', true)
        let id = this.$route.params.id;
        let self = this;
        this.$axios
          .get("/administration/livraisons/show/" + id)
          .then((response) => {
            this.id = response.data.livraison.id;
            this.titre = response.data.livraison.titre;
            this.numero_version = response.data.livraison.numero_version;
            this.contenu = response.data.livraison.contenu;
            this.commentaire = response.data.livraison.commentaire;
            this.date_livraison = response.data.livraison.date_livraison;
            this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false)
            if (error.response && error.response.status === 404 && self != undefined) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: `La livraison avec l'id ${id} n'existe pas`,
                showConfirmButton: false,
                timer: 5000
              });
              // this.$router.push({path: '/administration/livraisons/list'})
            }
          });
      },
    }
  }
</script>
